import { IPaging, IQueryParameters } from 'common/models';
import API from 'services/api';

interface IProps extends IPaging, IQueryParameters {}

export const getUsers = ({ pageNo, pageSize, params }: IProps) => {
  return API.get('/api/users', {
    params: { PageNo: pageNo, PageSize: pageSize, ...params },
  }).then(response => response?.data);
};
